// extracted by mini-css-extract-plugin
export default {"root":"Yj8AwLc2v_","list":"bSJqjJtDxI"};